import React from "react";

import { Text } from "@performyard/py-components";

type StatCardProps = {
	label: string;
	value?: React.ReactNode;
	trend?: React.ReactNode;
	children?: React.ReactNode;
	testId?: string;
};

export const StatCard = ({ label, value, trend, children, testId }: StatCardProps) => (
	<div
		className="box-border flex h-16 min-w-0 flex-1 flex-col gap-0.5 rounded-lg border border-solid border-neutral-2 bg-neutral-0 p-2"
		data-testid={testId}
	>
		<Text size="extra-small" color="neutral-5">
			{label}
		</Text>
		{children ?? (
			<div className="flex items-center gap-2">
				<Text size="heading-5" weight="semi-bold" color="neutral-9" wrap={false}>
					{value}
				</Text>
				{trend ?? null}
			</div>
		)}
	</div>
);

type StatRowProps = {
	label: string;
	value: React.ReactNode;
	icon?: React.ReactNode;
	testId?: string;
};

export const StatRow = ({ label, value, icon, testId }: StatRowProps) => (
	<div className="flex w-full items-center gap-1" data-testid={testId}>
		{icon ? <span className="flex shrink-0 items-center">{icon}</span> : null}
		<div className="min-w-0 flex-1">
			<Text size="caption" weight="semi-bold" color="neutral-9" wrap={false}>
				{label}
			</Text>
		</div>
		<Text size="caption" color="neutral-9" wrap={false}>
			{value}
		</Text>
	</div>
);

export const StatRows = ({ children }: { children: React.ReactNode }) => (
	<div className="flex w-full flex-col">{children}</div>
);
